import React, { useState } from 'react';
import HistoriqueTable2 from '../components/historique/historique.table2';
import { getAllSessions } from '../services/requestHandler';

export default function HistoriqueAdmin() {
  const [sessions, setSessions] = useState([{
    user_id: "",
    session_id: "",
    create_time: "",
    current_status: "",
    favoris: false,
    parent_session_reponse: [],
    update_time: "",
    
  }])

  React.useEffect(() => {
    getSessions();
  },[])

  async function getSessions() {
    const data = await getAllSessions()
    setSessions(data);
  }

  React.useEffect(() => {
  },[sessions])



  return (
    <div style={{backgroundColor:"white"}}>
        <HistoriqueTable2 />
    </div>
  );
}